var _ellipse, _g, _g2, _g3, _g4, _path, _g5, _g6, _g7, _g8, _g9, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar360X360({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 355.5,
    viewBox: "0 0 360 355.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "avatar-360x360",
    transform: "translate(-137 -274)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_467",
    "data-name": "Elipse 467",
    cx: 180,
    cy: 177.75,
    rx: 180,
    ry: 177.75,
    transform: "translate(137 274)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cabeza-robot",
    transform: "translate(176.401 348.725)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_543",
    "data-name": "Trazado 543",
    transform: "translate(185.366 74.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_574",
    "data-name": "Trazado 574",
    d: "M1356.6,1458.068h-48.186a4.759,4.759,0,1,1,0-9.519H1356.6a4.759,4.759,0,1,1,0,9.519Z",
    transform: "translate(-1303.658 -1448.549)",
    fill: "#19141e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_544",
    "data-name": "Trazado 544",
    transform: "translate(69.807 9.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_575",
    "data-name": "Trazado 575",
    d: "M1247.715,1440.207h-.015a4.759,4.759,0,0,1-4.744-4.775,21.518,21.518,0,0,1,21.4-21.4h.014a4.759,4.759,0,0,1,.013,9.519,11.975,11.975,0,0,0-11.911,11.913A4.76,4.76,0,0,1,1247.715,1440.207Z",
    transform: "translate(-1242.956 -1414.03)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_545",
    "data-name": "Trazado 545",
    transform: "translate(15.049 74.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_576",
    "data-name": "Trazado 576",
    d: "M1278.218,1458.068h-59.266a4.759,4.759,0,0,1,0-9.519h59.266a4.759,4.759,0,1,1,0,9.519Z",
    transform: "translate(-1214.192 -1448.549)",
    fill: "#19141e"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_546",
    "data-name": "Trazado 546",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_577",
    "data-name": "Trazado 577",
    d: "M1266,1554.156V1430.312A21.075,21.075,0,0,1,1287,1409.3h117.078a21.069,21.069,0,0,1,21.009,21.01v123.844a20.981,20.981,0,0,1,17.3,20.592v3a16.872,16.872,0,0,1,15.657,16.829v7.584H1233.049v-7.584a16.876,16.876,0,0,1,15.655-16.829v-3A20.986,20.986,0,0,1,1266,1554.156Zm212.095-65.381a20.412,20.412,0,1,1-20.414-20.41h0A20.409,20.409,0,0,1,1478.093,1488.775Zm-271.806,0a20.411,20.411,0,1,0,20.413-20.41h0A20.413,20.413,0,0,0,1206.287,1488.775Z",
    transform: "translate(-1206.287 -1409.302)",
    fill: "#dee3ff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_547",
    "data-name": "Trazado 547",
    transform: "translate(0 59.059)",
    opacity: 0.396,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_578",
    "data-name": "Trazado 578",
    d: "M1248.7,1549.713V1544.5a21.223,21.223,0,0,1,20.906-18.7h151.865a20.9,20.9,0,0,1,20.906,18.018v5.893a16.873,16.873,0,0,1,15.657,16.828v7.584H1233.049v-7.584a16.872,16.872,0,0,1,15.655-16.828Zm229.4-88.978a20.411,20.411,0,1,1-20.414-20.41h0a20.408,20.408,0,0,1,20.4,20.413Zm-271.812,0a20.411,20.411,0,1,1,20.412,20.412h0a20.41,20.41,0,0,1-20.412-20.408Z",
    transform: "translate(-1206.287 -1440.325)",
    fillRule: "evenodd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_548",
    "data-name": "Trazado 548",
    transform: "translate(43.75 164.191)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_765",
    "data-name": "Rect\\xE1ngulo 765",
    width: 191.871,
    height: 9.519,
    transform: "translate(0 0)",
    fill: "#19141e"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_549",
    "data-name": "Trazado 549",
    transform: "translate(92.46 106.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_766",
    "data-name": "Rect\\xE1ngulo 766",
    width: 126.338,
    height: 13.326,
    transform: "translate(0 0)",
    fill: "#19141e"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_550",
    "data-name": "Trazado 550",
    transform: "translate(117.866 47.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_579",
    "data-name": "Trazado 579",
    d: "M1275.814,1439.245a20.883,20.883,0,1,0,29.4,2.856h0a20.883,20.883,0,0,0-29.4-2.856",
    transform: "translate(-1268.201 -1434.487)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_551",
    "data-name": "Trazado 551",
    transform: "translate(133.143 59.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_580",
    "data-name": "Trazado 580",
    d: "M1279.72,1442.723a9.593,9.593,0,1,0,13.5,1.307,9.592,9.592,0,0,0-13.5-1.307l0,0",
    transform: "translate(-1276.226 -1440.533)",
    fill: "#19141e",
    fillRule: "evenodd"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_552",
    "data-name": "Trazado 552",
    transform: "translate(172.797 47.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_581",
    "data-name": "Trazado 581",
    d: "M1304.67,1439.245a20.883,20.883,0,1,0,29.4,2.856h0a20.884,20.884,0,0,0-29.4-2.856",
    transform: "translate(-1297.056 -1434.487)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_553",
    "data-name": "Trazado 553",
    transform: "translate(188.076 59.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_582",
    "data-name": "Trazado 582",
    d: "M1308.576,1442.723a9.594,9.594,0,1,0,13.505,1.307,9.59,9.59,0,0,0-13.505-1.307l0,0",
    transform: "translate(-1305.082 -1440.533)",
    fill: "#19141e",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar360X360);
export default __webpack_public_path__ + "static/media/avatar-360x360.3a9cf50a868f1db260ce0a70f8548594.svg";
export { ForwardRef as ReactComponent };